<template>
	<div class="home" @scroll="scrollEvent">
		<van-tabs @click="onClick" class="tabsList" color="#FF6900" v-model="active">
		  <van-tab title="申请表单"></van-tab>
		  <van-tab title="申请列表"></van-tab>
		</van-tabs>
		<div class="list">
			<div class="item" v-for="(item, index) in list" @click="toDetail(item)">
				<div class="item-01">
					<div class="item-01-left">驿站申请</div>
					<div v-if="item.status == '1'" class="item-01-right c01">未完成</div>
					<div v-if="item.status == '2'" class="item-01-right c02">未审核</div>
					<div v-if="item.status == '3'" class="item-01-right c03">审核通过</div>
					<div v-if="item.status == '4'" class="item-01-right c04">审核不通过</div>
				</div>
				<div class="item-02">
					<div class="item-02-text">申请单号：{{ item.apply_num }}</div>
					<div class="item-02-text">申请类型：{{ item.json.stadium_scale == undefined || item.json.stadium_scale == null ? '--' : item.json.stadium_scale }}</div>
					<div class="item-02-text">预计建设时间：{{ item.json.build_start_time == undefined || item.json.build_start_time == null ? '--' : item.json.build_start_time }}</div>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			active: 1,
			list: [],
			
			page: 1,
			page_size: 20,
		}
	},
	mounted() {
		var phone = localStorage.getItem('mobile')
		if(phone == '' || phone == null || phone == undefined){
			this.$router.push({
				name: 'unionslogin'
			})
			return
		}
		
		var data = {
			page: this.page,
			page_size: this.page_size,
			mobile: localStorage.getItem('mobile')
		}
		this.getList(data)
	},
	methods: {
		toDetail(item){
			if(item.status == '1' || item.status == '4'){
				this.$router.push({
					name: 'unionsdetail1',
					query: {
						id: item.id,
						status: item.status
					}
				})
			}else{
				this.$router.push({
					name: 'unionsdetail2',
					query: {
						id: item.id,
						status: item.status
					}
				})
			}
			
		},
		getList(data){
			this.$api.unions
				.getList(data)
				.then((res) => {
					if (res.status * 1 === 200) {
						res.data.list.forEach(item => {
							var json1 = {}
							var json2 = {}
							if(item.apply_one != ''){
								json1 = JSON.parse(item.apply_one)
							}
							if(item.apply_two != ''){
								json2 = JSON.parse(item.apply_two)
							}
							item.json = {...json1, ...json2}
						})
						this.list = this.list.concat(res.data.list)
						console.log("-1",this.list)
					}
				})
		},
		scrollEvent(e){
			// console.log("000000")
			if (e.srcElement.scrollTop + e.srcElement.clientHeight == e.srcElement.scrollHeight ) {
				console.log("嘿嘿我在底部触发了")
				this.page = this.page + 1
				var data = {
					page: this.page,
					page_size: this.page_size,
					mobile: localStorage.getItem('mobile')
				}
				this.getList(data)
			}
		},
		onClick(name, title) {
			console.log('ee', this.active)
			if(this.active == 0){
				this.$router.push({
					name: 'unionsform'
				})
			}
		},
	}
}
</script>

<style lang="less" scoped>
.tabsList{
	/deep/ .van-tabs__nav--card{
		margin: 0;
	}
}
.list{
	width: 95%;
	margin: auto;
	.item{
		border: 1px solid #eee;
		box-sizing: border-box;
		// padding: .1rem;
		margin-top: .3rem;
		.item-01{
			display: flex;
			font-size: .3rem;
			border-bottom: 1px solid #eee;
			box-sizing: border-box;
			padding: .1rem;
			background: #f4f4f4;
			justify-content: space-between;
			.item-01-left{
				color: #1989fa;
			}
			.item-01-right{
				
			}
		}
		.item-02{
			box-sizing: border-box;
			padding: .1rem .1rem .2rem .1rem;
			.item-02-text{
				font-size: .3rem;
				margin-top: .1rem;
				color: #999;
			}
		}
	}
}
.c01{
	color: #1989fa;
}
.c02{
	color: #ff976a;
}
.c03{
	color: #07c160;
}
.c04{
	color: #ee0a24;
}
</style>
